import * as styles from "./MiniIconButton.style.ts";
import type { HTMLProps, PropsWithChildren } from "react";

export const MiniIconButton = ({
  children,
  ...rest
}: PropsWithChildren<Omit<HTMLProps<HTMLButtonElement>, "type">>) => {
  return (
    <button {...rest} css={styles.root}>
      {children}
    </button>
  );
};
